<template>
  <div class="dsf_login_model">
    <div class="dsf_login_inner" :style="{ width: boxWidth }" v-if="!isLogin">
      <template>
        <el-tabs :tab-position="tabPosition" v-model="tabIndex">
          <el-tab-pane label="账号登录" name="textLogin">
            <textLogin
              ref="textLogin"
              :sourceUrl="sourceUrl"
              :nameHolder="nameHolder"
              :pwdHolder="pwdHolder"
              :codeHolder="codeHolder"
              :toUrl="toUrl"
              :login-success="_loginSuccess"
              :login-fail="_loginFail"
              @changePassword="changePassword"
              @toRegister="toRegister"
              :isreloadCurrentPage="isreloadCurrentPage"
            />
          </el-tab-pane>
          <el-tab-pane label="验证码登录" name="codeLogin">
            <codeLogin ref="codeLogin" :login-success="_loginSuccess" :login-fail="_loginFail" @changePassword="changePassword" @toRegister="toRegister" :isreloadCurrentPage="isreloadCurrentPage" />
          </el-tab-pane>
          <el-tab-pane label="微信登录" name="qrcode" v-if="dsf.config.setting_nc_tenement_wx_qrcode == '1'">
            <div id="wx_login_container2" key="wx_login_container2"></div>
          </el-tab-pane>
        </el-tabs>
      </template>
    </div>
    <div class="dsf_user_inner" v-else>
      <div class="user_info">
        <div class="name">
          {{ userName }}
          <dsf-icon name="bianji" @click="editUserInfo"></dsf-icon>
        </div>
        <div class="self_btn" @click="gotoPersonlCenter">个人中心</div>
      </div>
      <div class="study_year">
        <DsfNcMine itemWidth="100%" model="two"></DsfNcMine>
      </div>
      <div class="title">学习统计</div>
      <div class="study_count">
        <DsfNcLearningStatistics model="two" itemWidth="100%"></DsfNcLearningStatistics>
      </div>
    </div>
  </div>
</template>

<script>
import { textLogin, codeLogin } from "../../../base/login";
import { mapGetters } from "vuex";
export default({
  name: "DsfNcLoginModelNew",
  ctrlCaption: "登录",
  mixins: [$mixins.control],
  props: {
    title: {
      type: String,
      default: "登录",
    },
    moreUrl: {
      type: String,
      default: "/",
    },
    boxWidth: {
      type: String,
      default: "300px",
    },
    sourceUrl: {
      type: String,
      default: "/nc/login/login",
    },
    nameHolder: {
      type: String,
      default: "请输入账号",
    },
    pwdHolder: {
      type: String,
      default: "请输入密码",
    },
    codeHolder: {
      type: String,
      default: "动态验证码",
    },
    toUrl: {
      type: String,
      default: "",
    },
    loginSuccess: {
      type: Function,
      required: false,
    },
    loginFail: {
      type: Function,
      required: false,
    },
    noTitle: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isreloadCurrentPage: false,
      isview: true,
      tabIndex: "textLogin",

      wxLoginConfig: dsf.config.setting_nc_tenement_wx_qrcode == "1",
    };
  },
  created() {
    if (this.$dialog && !this.$dialog.$attrs["show-close"]) {
      this.isview = this.$dialog.$attrs["show-close"];
    }
  },
  mounted() {
    if (this.$dialog && this.$dialog.dialogArgs) {
      this.isreloadCurrentPage = this.$dialog.dialogArgs?.isreloadCurrentPage || false;
    }
    this.loadScript();
  },
  components: {
    textLogin,
    codeLogin,
  },
  watch: {
    tabIndex: {
      handler(v) {
        let that = this;
        document.onkeydown = function (e) {
          let key = e.keyCode;
          if (key == 13) that.$refs[v].loginHandle();
        };
        this.toggleWxLogin(v);
      },
      immediate: true,
    },
  },
  methods: {
    toggleWxLogin(type) {
      if (type == "qrcode") {
        this.$http.get("/nc/wechat/login/getConfig").then(({ data }) => {
          this.$nextTick(() => {
            let url = data.data.oathDomain + "/page.html#/pc/nc/page/pc/login/qrcode?type=1";
            var obj = new WxLogin({
              self_redirect: true,
              id: "wx_login_container2",
              appid: data.data.appId,
              scope: "snsapi_login",
              redirect_uri: encodeURIComponent(url),
              state: "",
              style: "",
              href: location.origin + "/static/wxlogin.css",
            });
          });
        });
      }
    },
    loadScript(callback) {
      var script = document.createElement("script");
      script.setAttribute("type", "text/javascript");
      script.setAttribute("src", "https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js");
      document.getElementsByTagName("head")[0].appendChild(script);
    },
    yes() {
      return new Promise(resolve => {
        this.resolve = resolve;
      });
    },

    _loginSuccess() {
      this.resolve?.(true);
      this.loginSuccess?.();
    },
    _loginFail() {
      this.resolve?.(false);
      this.loginFail?.();
    },
    changePassword() {
      const path = dsf.config.setting_public_login_forget_password;
      if (this.$listeners["changePwd"]) {
        this.$dispatch("changePwd", path);
      } else {
        path && dsf.layer.openWindow(path);
      }
    },
    toRegister() {
      const path = dsf.config.setting_public_login_register;
      if (this.$listeners["toRegister"]) {
        this.$dispatch("toRegister", path);
      } else {
        path && this.$open({ url: path, noTitle: !this.noTitle, state: 3, width: "430px", height: "440px", class: "register-dialog" });
        // path && this.$open({ url: path, state: 3, width: "400px", height: "auto", minHeight: "500px", class: "register-dialog" });
      }
    },
    gotoPersonlCenter() {
      this.$open({
        url: "/ncIndex.html#/pc/nc/pagepersonalCenter/index?active=",
      });
    },
    editUserInfo() {
      this.$open({ url: "/pc/nc/userinfo/edit", state: 3, width: "750px", title: "修改信息" });
    },
  },
  computed: {
    // isview() {
    //   return this.$route.query.isview == 1 ? false : true;
    // },
    isLogin() {
      return (dsf.getToken() && dsf.getToken() != "") || false;
    },
    ...mapGetters(["userName"]),
  },
});
</script>
